// Sprint 35 item 1 fix pass: what the door says once a mini-game is over. The chalk gets the game's step and always a total after it
// (a skip: the smear, then the unchanged total); the reveal card's big number is that total, and one sentence under it adds the door's
// own points and the game's up, so every number on the screen agrees. Display only: the server's points are the score.
const WORD = { bull: 'ride', bear: 'ducked', holden: 'held' }; // one verb with the chalk step (copy.js VERB): RIDE, DUCKED, HELD
const signed = n => `${n < 0 ? '-' : '+'}${Math.abs(n)}`;

export function miniCardLine({ game, mode, door, points, mult = 1, skipped = false, none = null }) {
  const head = `Door ${signed(door)}${mult > 1 ? ` (x${mult})` : ''}`;
  if (none) return `${head}. ${none}`; // a wrong call below the streak: the server sent the sentence (copy.js noRescueLine)
  if (skipped) return `${head}, game skipped.`;
  if (!(points > 0)) return `${head}, no points from the game.`;
  return `${head}, ${mode === 'rescue' ? 'rescue' : WORD[game] ?? 'game'} ${signed(points)}.`;
}

export function afterMini({ steps, revealPoints = 0, mult = 1, m }) {
  const points = Number.isFinite(m?.points) ? m.points : 0, total = revealPoints + points;
  const chalk = m?.chalk ?? { kind: 'mini', text: '- - -', smear: true };
  if (m?.none) return { steps: [...steps], total: revealPoints, cardPoints: revealPoints, line: miniCardLine({ door: revealPoints, mult, none: m.line }) }; // no game, so no chalk step
  return {
    steps: [...steps, chalk, { kind: 'total', text: `= ${total}`, value: total }],
    total, cardPoints: total,
    line: miniCardLine({ game: m?.game, mode: m?.mode, door: revealPoints, points, mult, skipped: !!m?.skipped }),
  };
}
